import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import React from "react";
import NcImage from "shared/NcImage/NcImage";
import I404Png from "images/404.png";
import SEO from "components/SEO/SEO";

const Page404: React.FC = () => (
  <div className="nc-Page404">
    <SEO
      title="Page Not Found | Nomadroof"
      description="Oops! The page you were looking for doesn't exist."
    />
    <div className="container relative pt-5 pb-16 lg:pb-20 lg:pt-5">
      <header className="text-center max-w-2xl mx-auto space-y-4">
        <NcImage src={I404Png} />
        <h1 className="text-4xl font-bold text-neutral-900 dark:text-neutral-100">
          Whoops! You've wandered off the map 🗺️
        </h1>
        <span className="block text-sm text-neutral-600 sm:text-base dark:text-neutral-400">
          Looks like this page packed its bags and moved somewhere else. Don't worry — your perfect room is still out there!
        </span>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <ButtonPrimary href="/">Return Home</ButtonPrimary>
          <ButtonSecondary href="/search">Browse Listings</ButtonSecondary>
        </div>
      </header>
    </div>
  </div>
);

export default Page404;